import React from 'react';
import { connect } from 'react-redux';

// Modules
import EmailOptInTrigger from 'core/modules/EmailOptInTrigger/EmailOptInTrigger';
import RedirectToTargetLandingPage from 'core/modules/RedirectToTargetLandingPage/RedirectToTargetLandingPage';
import PageErrorBoundary from 'core/modules/ErrorBoundaries/PageErrorBoundary';

import AcquisitionContainer from 'org/modules/Acquisition/Acquisition';

function Acquisition() {
  return (
    <RedirectToTargetLandingPage>
      <PageErrorBoundary>
        <div className="mn_acquisitionPage" data-test="acquisition">
          <AcquisitionContainer />
          <EmailOptInTrigger />
        </div>
      </PageErrorBoundary>
    </RedirectToTargetLandingPage>
  );
}

const mapStateToProps = () => ({});

export default connect(mapStateToProps)(Acquisition);
